// ChunkErrorBoundary.tsx
import { useEffect } from "react";

interface Props {
  children: React.ReactNode;
}

const ChunkErrorBoundary = ({ children }: Props) => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      const isChunkError =
        event.message.includes("Failed to fetch dynamically imported module") ||
        event.message.includes("Importing a module script failed");

      if (isChunkError) {
        const hasReloaded = sessionStorage.getItem("chunk_reload");
        if (!hasReloaded) {
          sessionStorage.setItem("chunk_reload", "true");
          window.location.reload();
        } else {
          sessionStorage.removeItem("chunk_reload");
        }
      }
    };

    window.addEventListener("error", handleError);
    return () => window.removeEventListener("error", handleError);
  }, []);

  return <>{children}</>;
};

export default ChunkErrorBoundary;